import {ReactElement, ReactNode} from 'react'
import {withStyles, WithStyles} from '@material-ui/core/styles'
import compose from 'lodash/flowRight'
import {withNamespaces, Trans} from 'react-i18next'
import {economicProfileQuestions} from '@bdswiss/common-enums'

import messages from '../../../../../assets/messages'
import {styles} from './styles'
import {FieldsSection} from '../FieldsSection'

type TradingKnowledgeAndExperienceProps = {
  renderQuestion: (question) => ReactNode
} & WithStyles

function TradingKnowledgeAndExperienceBase(props: TradingKnowledgeAndExperienceProps): ReactElement {
  const {
    classes,
    renderQuestion
  } = props

  return (
    <FieldsSection title={<Trans {...messages.tradingKnowledgeAndExperience} />}>
      <div className={classes.row}>
        {renderQuestion(economicProfileQuestions.relevantTradingEducationExperience)}
      </div>
      <div className={classes.row}>
        {renderQuestion(economicProfileQuestions.riskAwarenessOfCfdTrading)}
      </div>
    </FieldsSection>
  )
}

const TradingKnowledgeAndExperience = compose(withStyles(styles), withNamespaces())(TradingKnowledgeAndExperienceBase)
export {TradingKnowledgeAndExperience}
